module.exports = __webpack_public_path__ + "img/iconCheLiangGuanLi.45cfd9ae.svg";